(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/utils/get-vouchers.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/utils/get-vouchers.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const fetchData = async url => {
  try {
    return await svs.core.jupiter.get(url);
  } catch (e) {
    var _e$responseJSON$error, _e$responseJSON;
    return {
      error: (_e$responseJSON$error = e === null || e === void 0 || (_e$responseJSON = e.responseJSON) === null || _e$responseJSON === void 0 ? void 0 : _e$responseJSON.error) !== null && _e$responseJSON$error !== void 0 ? _e$responseJSON$error : e
    };
  }
};
const getVouchers = async giftcode => {
  if (giftcode) {
    return new Promise(async (resolve, reject) => {
      var _voucherMetadata$pers;
      svs.components.loader.show();
      const getVoucherMetaDataUrl = "/voucher/1/vouchermetadata?voucherId=".concat(giftcode.toUpperCase());
      const getVoucherUrl = "/voucher/6/getvoucher?voucherId=".concat(giftcode.toUpperCase());
      const [voucherMetadata, vouchersData] = await Promise.all([fetchData(getVoucherMetaDataUrl), fetchData(getVoucherUrl)]);
      svs.components.loader.hide();
      const personalMessage = voucherMetadata === null || voucherMetadata === void 0 || (_voucherMetadata$pers = voucherMetadata.personalMessage) === null || _voucherMetadata$pers === void 0 ? void 0 : _voucherMetadata$pers.replace(/\\n/g, '\n');
      if (!vouchersData.voucherInfo) {
        if ((voucherMetadata === null || voucherMetadata === void 0 ? void 0 : voucherMetadata.vouchers.length) === 1 && voucherMetadata.vouchers[0].voucherId === giftcode.slice(0, 8) && giftcode.length === 12) {
          resolve(_objectSpread(_objectSpread({}, voucherMetadata), {}, {
            vouchers: [_objectSpread(_objectSpread({}, voucherMetadata.vouchers[0]), {}, {
              voucherId: giftcode
            })]
          }));
        }
        reject(vouchersData.error);
      }
      if (!voucherMetadata.vouchers) {
        resolve(_objectSpread(_objectSpread(_objectSpread({}, voucherMetadata), vouchersData), {}, {
          personalMessage,
          vouchers: vouchersData.voucherInfo.map(voucher => _objectSpread(_objectSpread({}, voucher), {}, {
            voucherConfigId: voucher.packageId,
            value: voucher.voucherValue
          }))
        }));
      }
      resolve(_objectSpread(_objectSpread({}, voucherMetadata), {}, {
        personalMessage,
        receiverSameAsBuyer: vouchersData.receiverSameAsBuyer,
        vouchers: voucherMetadata.vouchers.map(metadata => _objectSpread(_objectSpread({}, metadata), {}, {
          voucherId: vouchersData.voucherInfo.find(voucher => voucher.voucherId.slice(0, 8) === metadata.voucherId).voucherId
        }))
      }));
    });
  }
  return {};
};
setGlobal('svs.ticket_gifts.utils.getVouchers', getVouchers);

 })(window);